import React from 'react';
import { Sidebar } from './Sidebar';
import { MainContent } from './MainContent';

interface AppLayoutProps {
  children: React.ReactNode;
}

/**
 * Single layout reused across all pages. No extra wrappers.
 * app-bg = page background (same as sidebar). layout = flex (Sidebar + MainContent).
 * MainContent = the one white curved container.
 */
export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const appShellBackground = 'linear-gradient(115.13deg, #EFFDFF 2.62%, #CFE5E7 41.03%, #CBF7FF 95.57%)';

  return (
    <div className="app-bg h-screen w-full overflow-hidden" style={{ background: appShellBackground }}>
      <div className="layout flex h-full w-full flex-col lg:flex-row" style={{ background: appShellBackground }}>
        <Sidebar />
        <MainContent>{children}</MainContent>
      </div>
    </div>
  );
};
